import type { BadgeProps } from '@chakra-ui/react';
import { Badge } from '@chakra-ui/react';
import { InvitationStatus } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

interface InvitationStatusBadgeProps extends Omit<BadgeProps, 'colorPalette'> {
  status: InvitationStatus | null | undefined;
}

const getStatuscolorPalette = (
  status: InvitationStatus | null | undefined
): BadgeProps['colorPalette'] => {
  switch (status) {
    case InvitationStatus.PENDING:
      return 'yellow';
    case InvitationStatus.CLICKED:
      return 'blue';
    case InvitationStatus.JOINED:
      return 'green';
    case InvitationStatus.EXPIRED:
      return 'red';
    default:
      return 'gray';
  }
};

const STATUS_LABEL_KEYS: Record<InvitationStatus, string> = {
  [InvitationStatus.PENDING]: 'invitations.status.pending',
  [InvitationStatus.CLICKED]: 'invitations.status.clicked',
  [InvitationStatus.JOINED]: 'invitations.status.joined',
  [InvitationStatus.EXPIRED]: 'invitations.status.expired',
  [InvitationStatus.UNDELIVERABLE]: 'invitations.status.undeliverable',
};

export const InvitationStatusBadge: React.FC<InvitationStatusBadgeProps> = ({
  status,
  ...badgeProps
}) => {
  const { t } = useTranslation();

  return (
    <Badge colorPalette={getStatuscolorPalette(status)} {...badgeProps}>
      {t(status ? STATUS_LABEL_KEYS[status] : 'invitations.status.unknown')}
    </Badge>
  );
};
